// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"headerIcon__2CMsz","header":"header__2S2lb","block":"block__217PL","reportCell":"reportCell__8KpGS"};